const crypto = require('crypto')

export default function getHashStr(str) {
    return crypto.createHash('SHA256').update(str.toString()).digest('hex')
}
